// extracted by mini-css-extract-plugin
export default {"cls1":"Autocomplete-cls1_v7H","cls2":"Autocomplete-cls2_ifv Autocomplete-cls1_v7H"};